import { Component, h, Host } from "@stencil/core";

/**
 * Webinar Summary component - used to display a summary of the webinar
 * this component may be used separately from the webinar component
 * it only provides styling
 * @slot - The content of the webinar summary (should be ux-iws-webinar-info elements)
 */
@Component({
    tag: "ux-iws-webinar-summary",
    styleUrl: "webinar-summary.scss",
    shadow: true,
})
export class WebinarSummary {
    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
